<template>
  <v-container fluid>
    <!-- KPIs Dashboard -->
    <v-row class="mb-4">
      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #4CAF50' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Total Entradas</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ kpiData.entrada_count || 0 }}
            </div>
            <div class="text-body-2">
              <span :class="kpiData.entrada_trend >= 0 ? 'success--text' : 'error--text'">
                <v-icon small :color="kpiData.entrada_trend >= 0 ? 'success' : 'error'">
                  {{ kpiData.entrada_trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down" }}
                </v-icon>
                {{ Math.abs(kpiData.entrada_trend || 0) }}%
              </span>
              respecto al periodo anterior
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #FF5252' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Total Salidas</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ kpiData.salida_count || 0 }}
            </div>
            <div class="text-body-2">
              <span :class="kpiData.salida_trend <= 0 ? 'success--text' : 'error--text'">
                <v-icon small :color="kpiData.salida_trend <= 0 ? 'success' : 'error'">
                  {{ kpiData.salida_trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down" }}
                </v-icon>
                {{ Math.abs(kpiData.salida_trend || 0) }}%
              </span>
              respecto al periodo anterior
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #2196F3' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Valor Entradas</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(kpiData.entrada_value || 0) }}
            </div>
            <div class="text-body-2">
              <span
                :class="
                  kpiData.entrada_value_trend >= 0 ? 'success--text' : 'error--text'
                "
              >
                <v-icon
                  small
                  :color="kpiData.entrada_value_trend >= 0 ? 'success' : 'error'"
                >
                  {{
                    kpiData.entrada_value_trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down"
                  }}
                </v-icon>
                {{ Math.abs(kpiData.entrada_value_trend || 0) }}%
              </span>
              respecto al periodo anterior
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-card
          class="mx-1 kpi-card"
          elevation="2"
          :style="{ borderTop: '4px solid #FF9800' }"
        >
          <v-card-text class="text-center py-4">
            <div class="text-overline mb-1">Valor Salidas</div>
            <div class="text-h5 font-weight-bold mb-2">
              {{ formatCurrency(kpiData.salida_value || 0) }}
            </div>
            <div class="text-body-2">
              <span
                :class="kpiData.salida_value_trend <= 0 ? 'success--text' : 'error--text'"
              >
                <v-icon
                  small
                  :color="kpiData.salida_value_trend <= 0 ? 'success' : 'error'"
                >
                  {{
                    kpiData.salida_value_trend >= 0 ? "mdi-arrow-up" : "mdi-arrow-down"
                  }}
                </v-icon>
                {{ Math.abs(kpiData.salida_value_trend || 0) }}%
              </span>
              respecto al periodo anterior
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Vista de escritorio -->
    <v-card class="mb-6" elevation="2">
      <v-card-title class="secondary white--text py-3 px-4">
        <v-icon color="white" class="mr-2">mdi-file-document-multiple</v-icon>
        <span>Documentos</span>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          class="mx-2"
          dark
          dense
          style="max-width: 300px"
        ></v-text-field>
        <v-text-field
          dark
          v-model="issueDate"
          label="Fecha"
          hide-details="auto"
          required
          dense
          outlined
          type="date"
          @input="get_notes"
          class="ml-2"
          style="max-width: 180px"
        />
        <v-menu open-on-hover transition="slide-x-transition" bottom right offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small v-bind="attrs" class="warning ml-3" v-on="on" fab>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <v-list class="pa-2" color="white">
            <v-list-item to="Receipt_in">
              <v-avatar size="24" class="mr-2">
                <v-icon>mdi-tray-arrow-up</v-icon>
              </v-avatar>
              <v-list-item-title>Comprobante Ingreso</v-list-item-title>
            </v-list-item>
            <v-list-item to="Receipt_out">
              <v-avatar size="24" class="mr-2">
                <v-icon>mdi-arrow-down</v-icon>
              </v-avatar>
              <v-list-item-title>Comprobante Egreso</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-title>

      <v-card-text class="pa-0">
        <!-- Vista de escritorio para pantallas md y mayores -->
        <div class="d-none d-md-block">
          <v-data-table
            :headers="headers"
            :items="credit_notes"
            :items-per-page="10"
            :search="search"
            sort-by="issuedate"
            :sort-desc="true"
            class="elevation-0"
            dense
            :loading="loading_status"
            loader-height="10"
            loading-text="Cargando..."
          >
            <!-- Template para el tipo de documento -->
            <template v-slot:[`item.doc_type`]="{ item }">
              <v-chip x-small :color="getDocTypeColor(item.doc_type)" text-color="white">
                {{ getDocTypeLabel(item.doc_type) }}
              </v-chip>
            </template>

            <!-- Template para el valor -->
            <template v-slot:[`item.doc_value`]="{ item }">
              <span>{{ formatCurrency(item.doc_value) }}</span>
            </template>

            <!-- Template para acciones -->
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small color="primary" @click.stop="get_e_doc(item)">
                mdi-magnify
              </v-icon>
            </template>
          </v-data-table>
        </div>

        <!-- Vista móvil solo para xs y sm -->
        <div class="d-md-none">
          <v-list two-line>
            <template v-if="!loading_status && credit_notes.length > 0">
              <v-list-item
                v-for="item in credit_notes"
                :key="item.id"
                @click="get_e_doc(item)"
                class="mb-2"
              >
                <v-list-item-content>
                  <v-list-item-title class="d-flex align-center">
                    <v-chip
                      x-small
                      :color="getDocTypeColor(item.doc_type)"
                      text-color="white"
                      class="mr-2"
                    >
                      {{ getDocTypeLabel(item.doc_type) }}
                    </v-chip>
                    <span class="font-weight-medium">{{ item.doc_number }}</span>
                  </v-list-item-title>

                  <v-list-item-subtitle>
                    <div class="d-flex flex-column">
                      <span class="mb-1">
                        <v-icon x-small class="mr-1">mdi-calendar</v-icon>
                        {{ formatDate(item.issuedate) }}
                      </span>
                      <span>
                        <v-icon x-small class="mr-1">mdi-account</v-icon>
                        {{ item.PartyName }}
                      </span>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <span class="font-weight-medium">
                    {{ formatCurrency(item.doc_value) }}
                  </span>
                </v-list-item-action>
              </v-list-item>
            </template>

            <!-- Estado de carga -->
            <v-list-item v-if="loading_status">
              <v-list-item-content class="text-center py-5">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  class="mb-2"
                ></v-progress-circular>
                <div class="caption">Cargando documentos...</div>
              </v-list-item-content>
            </v-list-item>

            <!-- Estado vacío -->
            <v-list-item v-if="!loading_status && credit_notes.length === 0">
              <v-list-item-content class="text-center py-5">
                <v-icon large color="grey lighten-1">mdi-file-document-outline</v-icon>
                <div class="caption grey--text mt-2">No hay documentos disponibles</div>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>
    </v-card>

    <!-- Mantener el noteViewer -->
    <noteViewer
      :item="item"
      :dialog="dialog"
      @close="dialog = false"
      @refresh="refresh()"
    />
  </v-container>
</template>

<script>
import { webserver, getToday } from "../services/webserver.js";
import noteViewer from "../components/doc_viewer_report.vue";

export default {
  components: { noteViewer },
  data() {
    return {
      kpiData: {
        entrada_count: 0,
        salida_count: 0,
        entrada_value: 0,
        salida_value: 0,
        entrada_trend: 0,
        salida_trend: 0,
        entrada_value_trend: 0,
        salida_value_trend: 0,
      },
      search: "",
      errors: [],
      valid: false,
      loading_status: false,
      f_required: [(v) => !!v || "Requerido"],
      f_email: [
        (v) => !!v || "Correo valido",
        (v) => /.+@.+/.test(v) || "Correo no valido",
      ],
      imageUrl: null,
      dialog: false,
      headers: [
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "doc_type",
          width: "100px",
        },
        {
          text: "Fecha",
          align: "start",
          sortable: true,
          value: "issuedate",
        },
        {
          text: "Documento",
          align: "start",
          sortable: true,
          value: "doc_number",
        },
        {
          text: "Tercero",
          align: "start",
          sortable: true,
          value: "PartyName",
        },
        {
          text: "Valor",
          align: "end",
          sortable: true,
          value: "doc_value",
        },
        {
          text: "Acciones",
          align: "center",
          value: "actions",
          sortable: false,
          width: "80px",
        },
      ],
      credit_notes: [],
      item: {
        document: {
          doc_type: null,
          doc_number: null,
          store: null,
          issuedate: null,
          cufe: null,
        },
        items: [],
        payments: [],
        buyer: {
          PartyEmail: null,
        },
      },
      issueDate: getToday(),
    };
  },
  mounted() {
    this.get_notes();
  },
  methods: {
    getDocTypeColor(docType) {
      switch (docType) {
        case "CS-IN":
          return "success";
        case "CS-OUT":
          return "error";
        default:
          return "grey";
      }
    },
    getDocTypeLabel(docType) {
      switch (docType) {
        case "CS-IN":
          return "Entrada";
        case "CS-OUT":
          return "Salida";
        default:
          return docType;
      }
    },
    formatDate(dateString) {
      if (!dateString) return "";
      return dateString.split(" ")[0];
    },
    formatCurrency(value) {
      if (!value && value !== 0) return "";
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value);
    },
    refresh() {
      this.get_notes();
    },
    async get_notes() {
      this.loading_status = true;
      try {
        // Obtener datos del período actual
        const currentData = await this.fetchDocuments(this.issueDate);

        // Obtener datos del período anterior
        const previousDate = new Date(this.issueDate);
        previousDate.setDate(previousDate.getDate() - 1);
        const previousData = await this.fetchDocuments(
          previousDate.toISOString().split("T")[0]
        );

        // Calcular KPIs
        this.calculateKPIs(currentData, previousData);

        // Actualizar la tabla
        this.credit_notes = currentData;
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.loading_status = false;
      }
    },
    async fetchDocuments(date) {
      return new Promise((resolve, reject) => {
        const qry = {
          store: window.store.store_id,
          table: "docs",
          filters: [
            {
              field: "doc_type",
              operator: " IN ",
              value: "'CS-IN','CS-OUT'",
            },
            {
              field: "DATE(issuedate)",
              operator: "=",
              value: date,
            },
            {
              field: "store",
              operator: "=",
              value: window.store.store_id,
            },
          ],
        };

        if (this.$store.getters.profile.user_access == "USUARIO") {
          qry.filters.push({
            field: "userId",
            operator: "=",
            value: this.$store.state.profile.email,
          });
        }

        webserver(
          "get_dataTable",
          qry,
          (data) => {
            resolve(data || []);
          },
          (error) => {
            reject(error);
          }
        );
      });
    },
    calculateKPIs(currentData, previousData) {
      // Función auxiliar para calcular tendencias
      const calculateTrend = (current, previous) => {
        if (previous === 0) return 0;
        return Math.round(((current - previous) / previous) * 100);
      };

      // Calcular métricas actuales
      const currentMetrics = {
        entrada_count: currentData.filter((doc) => doc.doc_type === "CS-IN").length,
        salida_count: currentData.filter((doc) => doc.doc_type === "CS-OUT").length,
        entrada_value: currentData
          .filter((doc) => doc.doc_type === "CS-IN")
          .reduce((sum, doc) => sum + (parseFloat(doc.doc_value) || 0), 0),
        salida_value: currentData
          .filter((doc) => doc.doc_type === "CS-OUT")
          .reduce((sum, doc) => sum + (parseFloat(doc.doc_value) || 0), 0),
      };

      // Calcular métricas anteriores
      const previousMetrics = {
        entrada_count: previousData.filter((doc) => doc.doc_type === "CS-IN").length,
        salida_count: previousData.filter((doc) => doc.doc_type === "CS-OUT").length,
        entrada_value: previousData
          .filter((doc) => doc.doc_type === "CS-IN")
          .reduce((sum, doc) => sum + (parseFloat(doc.doc_value) || 0), 0),
        salida_value: previousData
          .filter((doc) => doc.doc_type === "CS-OUT")
          .reduce((sum, doc) => sum + (parseFloat(doc.doc_value) || 0), 0),
      };

      // Actualizar KPIs
      this.kpiData = {
        entrada_count: currentMetrics.entrada_count,
        salida_count: currentMetrics.salida_count,
        entrada_value: currentMetrics.entrada_value,
        salida_value: currentMetrics.salida_value,
        entrada_trend: calculateTrend(
          currentMetrics.entrada_count,
          previousMetrics.entrada_count
        ),
        salida_trend: calculateTrend(
          currentMetrics.salida_count,
          previousMetrics.salida_count
        ),
        entrada_value_trend: calculateTrend(
          currentMetrics.entrada_value,
          previousMetrics.entrada_value
        ),
        salida_value_trend: calculateTrend(
          currentMetrics.salida_value,
          previousMetrics.salida_value
        ),
      };
    },
    get_e_doc(e) {
      var issudate = e.issuedate.split(" ");
      console.log(issudate[0]);
      var doc = {
        store: e.store,
        issueDate: issudate[0],
        did: e.doc_number,
      };
      console.log(doc);
      webserver("get_invoice_fe", doc, (data) => {
        console.log(data);
        this.item = data;
        this.dialog = true;
        // data.doc.doc_type = "Invoice";
        this.loading_vendors = false;
      });
    },
  },
};
</script>

<style>
/* Estilos para la vista móvil */
.v-list-item {
  border-radius: 4px;
  margin: 4px 8px;
  background-color: white !important;
}

.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.03) !important;
}

.v-list-item__subtitle {
  margin-top: 4px !important;
}

.caption {
  font-size: 0.75rem !important;
}

.v-list-item__title {
  font-size: 1rem !important;
  line-height: 1.2 !important;
}

/* Mejoras en la responsividad */
@media (max-width: 600px) {
  .v-list-item {
    padding: 12px !important;
  }

  .v-list-item__content {
    padding: 4px 0 !important;
  }
}

/* Estilos para la tabla */
.v-data-table >>> .v-data-table__wrapper {
  overflow-x: auto;
}

.v-data-table >>> th {
  background-color: #f5f5f5 !important;
  font-weight: bold !important;
  white-space: nowrap;
}

.v-data-table >>> tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

.v-data-table >>> tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.primary {
  background-color: #1976d2 !important;
}

.v-card-title.primary {
  border-radius: 4px 4px 0 0;
}
</style>
